import React from "react";
import DOMPurify from "dompurify";
import InfoIcon from "@mui/icons-material/Info";

import { ClickAwayListener } from "@mui/material";
import { CardStyled, TextTipStyled, TooltipStyled } from "./styles";

interface ITooltipBody {
  content: string;
}

const TipBody = (props: ITooltipBody): React.JSX.Element => {
  return (
    <CardStyled
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(props.content || ""),
      }}
    ></CardStyled>
  );
};

const TooltipBody = (props: ITooltipBody): React.JSX.Element => {
  const [open, setOpen] = React.useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };
  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <div>
        <TooltipStyled
          slotProps={{
            popper: {
              disablePortal: true,
            },
          }}
          onClose={handleTooltipClose}
          open={open}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          title={<TipBody content={props.content} />}
        >
          <div>
            <InfoIcon fontSize="small" color="primary" />
            <TextTipStyled onClick={handleTooltipOpen}>
              Onde localizar seu grupo e cota no extrato
            </TextTipStyled>
          </div>
        </TooltipStyled>
      </div>
    </ClickAwayListener>
  );
};

export default TooltipBody;
